import React from 'react'
import { Button } from 'pcln-design-system'

function FindYourDealButton({
  currentProduct = '',
  formButtonProps,
  hasMinWidth,
  isLargeInput
}: {
  currentProduct: string
  formButtonProps?: any
  hasMinWidth?: boolean
  isLargeInput?: boolean
}) {
  const buttonText = `Find Your ${currentProduct
    .charAt(0)
    .toUpperCase()}${currentProduct.slice(1, -1)}`
  return (
    <Button
      m={0}
      width={1}
      size="large"
      style={{
        whiteSpace: 'nowrap',
        minWidth: hasMinWidth ? '165px' : null,
        height: isLargeInput ? '56px' : null
      }}
      {...formButtonProps}
    >
      {buttonText}
    </Button>
  )
}

export default FindYourDealButton
